'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _rx = require('rx');

var publishState = Symbol('publishState');
var publishError = Symbol('publishError');

var observableSymbol = Symbol('observable');

var Store = (function (_Observable) {
    _inherits(Store, _Observable);

    function Store(initialValue) {
        var _this = this;

        _classCallCheck(this, Store);

        var replaySubject = new _rx.ReplaySubject(1);

        _get(Object.getPrototypeOf(Store.prototype), 'constructor', this).call(this, (function observerCreator(observer) {
            return this.subscribe(observer.onNext.bind(observer), observer.onError.bind(observer), observer.onCompleted.bind(observer));
        }).bind(replaySubject));

        this[observableSymbol] = replaySubject;

        if (initialValue) {
            Promise.resolve(initialValue).then(function (value) {
                _this.setState(value);
            })['catch'](function (error) {
                _this[publishError](error);
            });
        }
    }

    _createClass(Store, [{
        key: 'setState',
        value: function setState(newState) {
            this.state = newState;
            this[publishState]();
        }
    }, {
        key: 'getState',
        value: function getState() {
            return this.state;
        }
    }, {
        key: 'setSource',
        value: function setSource(observableSource) {
            var _this2 = this;

            observableSource.subscribe(function (value) {
                return _this2.setState(value);
            }, function (error) {
                return _this2[publishError]('Rethrown error from source: ' + error);
            });
        }

        /** ***************************************************************************************************************
         * Private methods
         *****************************************************************************************************************/

    }, {
        key: publishState,
        value: function value() {
            return this[observableSymbol].onNext(this.state);
        }
    }, {
        key: publishError,
        value: function value(error) {
            return this[observableSymbol].onError(error);
        }

        /** ***************************************************************************************************************
         * Static methods
         *****************************************************************************************************************/

    }], [{
        key: 'create',
        value: function create(storeConfig) {
            var initialState = undefined;
            var mergeObject = {};

            if (storeConfig) {
                if (storeConfig.getInitialValue) {
                    initialState = storeConfig && storeConfig.getInitialState();
                }

                Object.keys(storeConfig).filter(function (keyName) {
                    return keyName !== 'getInitialState';
                }).forEach(function (keyName) {
                    mergeObject[keyName] = storeConfig[keyName];
                    return mergeObject;
                });
            }

            return Object.assign(new Store(initialState), mergeObject);
        }
    }]);

    return Store;
})(_rx.Observable);

exports['default'] = Store;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ../~/d2-flux/store/Store.js
 ** module id = 168
 ** module chunks = 0
 **/